import * as React from "react";

export type LoaderContextProps = {
    setLoaderState: (id: string, state: boolean)=>void
}

export const LoaderContext = React.createContext<LoaderContextProps>({
    setLoaderState: ()=>{}
})